import React, {useEffect, useMemo, useState} from 'react';

import Button from '../button/Button';
import InputField from '../inputField/InputField';
import PlaylistGroupForm from '../playlistGroupForm/PlaylistGroupForm';
import Loader from '../loader/Loader';
import {playlistStore} from '../../store';
import {useTranslation} from 'react-i18next';
import {type PlaylistGroup, type User,} from '../../api/types/index';

type PropsTypes = {
    user: User;
    playlistGroup: PlaylistGroup;
    onCancel: () => void;
    onSuccess: () => void;
};

const EditPlaylistGroup = (props: PropsTypes) => {
    const { t } = useTranslation();
    const { updatePlaylistGroup } = playlistStore();
    const [playlistDescription, setPlaylistDescription] = useState<string>('');

    const [playlistTitle, setPlaylistTitle] = useState<string>('');

    const [market, setMarket] = useState<string>('');

    const [loading, setLoading] = useState<boolean>(true);

    const [isSaving, setIsSaving] = useState<boolean>(false);
 
    useEffect(() => {
        setPlaylistDescription(props.playlistGroup.description);
        setPlaylistTitle(props.playlistGroup.title);
        setLoading(false);
    }, []);

    useEffect(() => {
        const { user } = props;
    }, [props.user]);

    const onSaveEditClick = async () => {
        const options = {
            title: playlistTitle,
            description: playlistDescription
        };

        setIsSaving(true);
        
        await updatePlaylistGroup(options);
        setIsSaving(false);

        if (props.onSuccess) {
            props.onSuccess();
        }
    };

    const handleDescriptionChange = e => {
        setPlaylistDescription(e.target.value);
    };

    const handleTitleChange = value => {
        setPlaylistTitle(value);
    };

    const isMarketEditationDisabled = (): boolean => {
        return props.playlistGroup.items.length > 0 || props.playlistGroup.devices.length > 0;
    };

    const { onCancel, user } = props;

    if (loading) {
        return <Loader loading={loading} />;
    }
    return (
        <div className="description">
            <div className="edit">
                <div className="inputs">
                    <div className="input-group">
                        <div className="left-side">
                            <PlaylistGroupForm
                                user={user}
                                title={playlistTitle}
                                onTitleChange={handleTitleChange}
                            />
                        </div>
                        <div className="right-side">
                            <InputField
                                label={t('device_detail_edit_description_title')}
                                name="description"
                                inputType="textarea"
                                onChangeHandler={handleDescriptionChange}
                                value={playlistDescription}
                            />
                        </div>
                    </div>
                    <div className="target">
                        {market}
                    </div>
                </div>
                <div className="b-modal-action-buttons edit-buttons">
                    <Button
                        secondaryButton
                        text={t('cancel')}
                        clickHandler={onCancel}
                    />
                    <Button
                        disabled={playlistTitle.length === 0}
                        isLoading={isSaving}
                        text={t('save')}
                        clickHandler={onSaveEditClick}
                    />
                </div>
            </div>
        </div>
    );
};

export default EditPlaylistGroup;
